'use client'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { ButtonAsA, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Colors } from '@b-stock/fe-core/design-system'

import { LINKS } from './content'
import { Inner, Section, SectionBody, SectionTitle } from './ui'

const TeaserInner = styled(Inner)`
  @media ${Breakpoints.min.large} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 3rem;
  }
`

const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const Cta = styled(ButtonAsA)`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0.5rem;
  width: fit-content;
`

export default function ResourceCenterTeaser() {
  return (
    <Section
      $background={Colors.Semantic.BStock.background.lightBackground}
      data-testid="logged-out-resource-center"
    >
      <TeaserInner>
        <Copy>
          <SectionTitle>
            <FormattedMessage id="LoggedOutHomepage.resourceCenter.title" />
          </SectionTitle>
          <SectionBody>
            <FormattedMessage id="LoggedOutHomepage.resourceCenter.body" />
          </SectionBody>
        </Copy>
        <Cta
          appearance="secondary"
          size="large"
          href={LINKS.buyerResourceCenter}
        >
          <FormattedMessage id="LoggedOutHomepage.resourceCenter.cta" />
          <FontAwesomeIcon icon={faArrowRight} />
        </Cta>
      </TeaserInner>
    </Section>
  )
}
